/* 
 * Vue component used for registration pages.
*/

import Vue from 'vue';

function getCss(value, valid) {
    if (value == null || value == "") {
        return "none";
    } else if (valid) {
        return "success";
    } else {
        return "fail";
    }
}

Vue.component('submit-contest-form', {
    template: `
<div>
  <div class="row">

    <div class="col-md-6 form-fieldset">
      <label for="firstName">{{ labels.first }}</label> 
      <input id="firstName" 
             name="firstName" 
             v-model="form.firstName" 
             v-validate="'required'"
             v-bind:class="fields.firstName"
             type="text" 
             class="form-control"> 
      <error v-show="errors.has('firstName:required')">{{ validation.required }}</error>
    </div> 

    <div class="col-md-6 form-fieldset ">
      <label for="lastName">{{ labels.last }}</label> 
      <input id="lastName" 
             name="lastName" 
             v-model="form.lastName" 
             v-validate="'required'"
             v-bind:class="fields.lastName"
             type="text" 
             class="form-control"> 
      <error v-show="errors.has('lastName:required')">{{ validation.required }}</error>
    </div>

  </div> 

  <div class="row">

    <div class="col-md-12 form-fieldset">
      <label for="email">{{ labels.email }}</label> 
      <input id="email" 
             name="email" 
             v-model="form.email" 
             v-validate="'required|email'" 
             v-bind:class="fields.email"
             type="text" 
             class="form-control"
             @valid="regexValid" >
      <error v-show="errors.has('email:required')">{{ validation.required }}</error>
      <error v-show="errors.has('email:email')">{{ validation.emailFormat }}</error>
    </div>

  </div>
  
    <div class="row">
        <div class="col-md-12 form-fieldset">
            <label for="socialMediaHandle">{{ labels.socialMediaHandle }}</label>
            <input id="socialMediaHandle"
                    name="socialMediaHandle"
                    v-model="form.socialMediaHandle"
                    v-validate="'required'"
                    v-bind:class="fields.socialMediaHandle"
                    type="text"
                    class="form-control">
            <error show="errors.has('socialMediaHandle:required')">{{ validation.required }}</error>
        </div>
    </div>
        
    <div class="row">
        <div class="col-md-12 form-fieldset">
            <label for="submissionLink">{{labels.submissionLink}}</label>
            <input id="submissionLink"
                    name="submissionLink"
                    v-model="form.submissionLink"
                    v-validate="'required'"
                    v-bind:class="fields.submissionLink"
                    placeholder="http://yoursubmission.com"
                    pattern="http://.*"
                    type="text"
                    class="form-control">
            <error show="errors.has('submissionLink:required')">{{ validation.required }}</error>
        </div>
    </div>

</div>`,
    props: ["form", "labels", "placeholders", "validation", "documentName"],
    data() {
        return {
            isEmailValid: false
        };
    },
    computed: {
        validationClass() {
            var regex = /^[^ <>()\[\]\,;:\s@]+@[^ <>()\[\]\,;:\s@]+\.[a-zA-Z]{2,}$/igm;
            var valid = regex.test(form.email);
            this.$emit('valid', { type: form.email, valid: valid });
            return getCss(this.email, valid);
        }
    },
    methods: {
        regexValid(event) {
            console.log("regexValid!!!!");
            this[event.type] = event.valid;
            var valid = this.isEmailValid;

            this.$emit('valid', valid);
        }
    }
});



// WEBPACK FOOTER //
// ./Content/js/app/components/vc-submit-contest-form.js